/** Clases compartidas: botones fijos PSE/WhatsApp vs. franja inferior del footer. */

/** Separación desde el borde inferior del viewport. */
export const FLOATING_ACTION_BOTTOM_CLASS = 'bottom-6 sm:bottom-8';

/** Espacio vacío bajo copyright/enlaces para que los botones no los tapen. */
export const FOOTER_FLOAT_PADDING_CLASS = 'pb-28 sm:pb-32';

/** Márgenes horizontales en la franja de copyright (PSE izq., WhatsApp der.). */
export const FOOTER_FLOAT_INSET_X_CLASS =
  'pl-[4.75rem] pr-[4.75rem] sm:pl-24 sm:pr-24 lg:pl-[13rem] lg:pr-28';
